<template>
  <div class="school-orders">
    <v-row>
      <v-col cols="12" md="3">
        <SchoolNavigation />
      </v-col>
      <v-col cols="12" md="9">
        <v-sheet color="white" class="pa-5" rounded>
          <h3>سفارش دهید ...</h3>
          <v-alert
            border="left"
            colored-border
            type="info"
            elevation="2"
            class="mt-5"
          >
            برای هر سری سفارش جدید،کافیست یک نام برای سفارش خود بنویسید و تعداد
            سفارش را در مقابل آن وارد کنید تا فاکتور شما صادر شود. بعد از اتمام
            فرایند پرداخت، کدهای تخفیف تولید شده را می توانید از بخش کنترل پنل
            مدرسه، در لیست سفارشات مشاهده و چاپ نمایید.
          </v-alert>
          <form-alert v-if="error" :message="error.response.data.message" />
          <v-form
            v-model="valid"
            @submit.prevent="handleDiscountCreate"
            class="text-center"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="title"
                  :rules="titleRules"
                  label="نام سری کد تحفیف"
                  placeholder="مثال: دانش آموزان پایه دوم ..."
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  v-model="count"
                  :rules="countRules"
                  label="تعداد کد تحفیف"
                  placeholder="تعداد دانش آموزان ضرب در تعداد کتاب ها"
                  required
                />
              </v-col>
            </v-row>
            <v-simple-table dense v-if="valid" class="mb-8">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="font-weight-bold">قیمت واحد</td>
                    <td>
                      <strong>{{ price }}</strong> <small>تومان</small>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">تعداد درخواستی</td>
                    <td>
                      <strong>{{ count }}</strong> <small>عدد</small>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">جمع فاکتور</td>
                    <td>
                      <strong>{{ totalPrice }}</strong> <small>تومان</small>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">درصد تخفیف</td>
                    <td>
                      <strong>{{ discount }}</strong> <small>%</small>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">قیمت نهایی</td>
                    <td>
                      <strong>{{ disTotalPrice }}</strong> <small>تومان</small>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-btn
              depressed
              block
              color="success"
              class="flex-grow-1"
              v-if="discount === 100 && valid"
              @click="handleAddDiscount"
            >
              فعال سازی
            </v-btn>
            <v-btn
              :loading="this.loading"
              :disabled="this.loading"
              depressed
              block
              color="primary"
              type="submit"
              class="flex-grow-1"
              v-if="discount != 100 && valid"
            >
              پرداخت <strong class="mx-2">{{ disTotalPrice }}</strong>
              <small>ریال</small>
            </v-btn>
            <div
              v-if="!valid"
              class="flex-fill grey lighten-3 grey--text py-2 rounded"
            >
              غیر قابل انجام ...
            </div>
          </v-form>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SchoolNavigation from "./SchoolNavigation";
export default {
  name: "create-school-order-component",
  components: {
    SchoolNavigation
  },
  data: () => {
    return {
      loading: false,
      valid: true,
      error: null,
      title: "",
      titleRules: [(v) => !!v || "وارد کردن نام سری کد اجباری است"],
      count: null,
      countRules: [
        (v) => !!v || "وارد کردن تعداد کد اجباری است",
        (v) => v >= 20 || "حداقل تعداد کد به ازای سفارش 20 عدد است",
        (v) => v <= 1000 || "حداکثر تعداد کد به ازای هر سفارش 1000 عدد است",
        (v) => v % 5 == 0 || "تعداد سفارش باید ضریبی از عدد 5 باشد"
      ],
      price: 120000,
      discount: null,
      disPrice: null
    };
  },
  computed: {
    totalPrice: function () {
      return this.count * this.price;
    },
    disTotalPrice: function () {
      return this.count * this.disPrice;
    }
  },
  created() {
    this.handleGetSchool();
  },
  methods: {
    handleGetSchool() {
      this.$api.get("user/school/").then((res) => {
        const school = res.data.school;
        this.discount = school.discountPercent;
        this.disPrice = this.price - (this.price * this.discount) / 100;
      });
    },
    handleAddDiscount() {
      this.$api
        .post("order/add", {
          amount: 0,
          type: "کد تخفیف",
          discountCodeTitle: this.title,
          discountCodeCount: this.count,
          verify: true
        })
        .then((res) => {
          const order = res.data.order;
          this.$api
            .post("/order/discountCode/verify", {
              orderId: order.orderId
            })
            .then(() => {
              this.$router.push("/School/Orders");
            });
        });
    },
    handleDiscountCreate() {
      this.loading = true;
      this.$api
        .post("order/add", {
          amount: this.disTotalPrice,
          type: "کد تخفیف",
          discountCodeTitle: this.title,
          discountCodeCount: this.count
        })
        .then((res) => {
          location.replace(res.data.url);
        });
    }
  }
};
</script>
